export default __webpack_public_path__ + "static/media/bg-shape-2.95c33d01.png";